var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"purchase-edit"}},[_c('h2',[_vm._v("Edit Purchase #"+_vm._s(_vm.purchaseId))]),_vm._v(" "),_c('purchase-nav',{attrs:{"purchaseId":_vm.purchaseId}}),_vm._v(" "),_c('purchase-form',{attrs:{"purchaseId":_vm.purchaseId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21529419","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseEdit.vue
// module id = 1147
// module chunks = 1